import { forwardRef } from "react";

export const Radio = forwardRef(
  ({ checked, onChange, size, style, className, id }, ref) => {
    return (
      <>
        <input
          type="radio"
          id={id}
          checked={checked}
          onChange={onChange}
          className="sr-only"
          ref={ref}
        />
        {checked ? (
          <img
            onClick={onChange}
            src="/assets/icons/radio_a.svg"
            alt="Selected radio button"
            style={{
              height: size ? size : 15,
              width: size ? size : 15,
              ...style,
            }}
            className={className}
          />
        ) : (
          <img
            onClick={onChange}
            src="/assets/icons/radio_d.svg"
            alt="Unselected radio button"
            style={{
              height: size ? size : 15,
              width: size ? size : 15,
              ...style,
            }}
            className={className}
          />
        )}
      </>
    );
  }
);

Radio.displayName = "Radio";

export default Radio;
